import { useRouter } from 'next/router';
import { ROUTES } from '@/constants/routes';
import { AdStatus } from '@/types';
import { useNavigationStore } from '@/store/useNavigationStore';

export function useMobileProfileHeader() {
  const router = useRouter();
  const [canGoBack, goBack] = useNavigationStore(state => [
    state.canGoBack,
    state.goBack,
  ]);

  function handleBack() {
    if (canGoBack) {
      goBack();
      return;
    }

    router.push(ROUTES.profileAds(AdStatus.Published));
  }

  return { handleBack };
}
